export const EVENT_KEY = {
    ENTER: "Enter",
    SPACE: " ",
    ARROW_LEFT: "ArrowLeft",
    ARROW_RIGHT: "ArrowRight",
    ARROW_UP: "ArrowUp",
    ARROW_DOWN: "ArrowDown",
    ESCAPE: "Escape",
}

export const isArrowLeftKeyEvent = e => e.key === EVENT_KEY.ARROW_LEFT
export const isArrowRightKeyEvent = e => e.key === EVENT_KEY.ARROW_RIGHT
export const isArrowUpKeyEvent = e => e.key === EVENT_KEY.ARROW_UP
export const isArrowDownKeyEvent = e => e.key === EVENT_KEY.ARROW_DOWN
export const isEnterKeyEvent = e => e.key === EVENT_KEY.ENTER
export const isSpaceKeyEvent = e => e.key === EVENT_KEY.SPACE
export const isEscapeKeyEvent = e => e.key === EVENT_KEY.ESCAPE

export const isKeyboardClickEvent = e => isEnterKeyEvent(e) || isSpaceKeyEvent(e)
